import { schemeOranges, schemeBlues } from "d3-scale-chromatic";

// Arrays

// For Map Options
export let mapOptions = [
    {
        option: "noData",
        title: "Base Map"
    },
    { option: "sampleData", title: "Sample Dataset" },
    {
        option: "customData",
        title: "Custom Dataset"
    }

];

// For map classifications

export let classificationMethods = [
    { option: "EqualInterval", title: "Equal Interval" },
    {
        option: "StandardDeviation",
        title: "Standard Deviation"
    },
    {
        option: "ArithmeticProgression",
        title: "Arithmetic Progression"
    },
    { option: "Quantile", title: "Quantile" }
];

// Color Options for customization

export let colourSchemes = [
    { option: schemeBlues, title: "Blues" }
    
];

// join functions
// mostly copied over from florence-datacontainer
// built in extra check if key doesn't exist on left-hand side of join
export function join(left, right, by) {
    const leftData = left.data()
    const rightData = right.data()

    const joinColumns = initJoinColumns(rightData, by[1])
    const rightRowsByKey = generateRightRowsByKey(rightData, by[1])
    const leftByColumn = leftData[by[0]]
    const colNames = rightRowsByKey[Object.keys(rightRowsByKey)[0]]
    for (let i = 0; i < leftByColumn.length; i++) {
        const leftKey = leftByColumn[i]
        const row = rightRowsByKey[leftKey]
        // if we have non-matching data on the right
        // create undefined entries
        if (row === undefined) {
            for (const columnName in colNames) {
                joinColumns[columnName].push(undefined)
            }
        } else { // there's a match, copy over data
            for (const columnName in row) {
                joinColumns[columnName].push(row[columnName])
            }
        }
    }
    return joinColumns
}

function generateRightRowsByKey(right, byColumnName) {
    const rightRowsByKey = {}
    const byColumn = right[byColumnName]

    for (let i = 0; i < byColumn.length; i++) {
        const key = byColumn[i]
        const row = {}

        for (const columnName in right) {
            if (columnName !== '$key' && columnName !== byColumnName) {
                row[columnName] = right[columnName][i]
            }
        }
        rightRowsByKey[key] = row
    }
    return rightRowsByKey
}

function initJoinColumns(right, byColumnName) {
    const joinColumns = {}

    for (const columnName in right) {
        if (columnName !== '$key' && columnName !== byColumnName) {
            joinColumns[columnName] = []
        }
    }

    return joinColumns
}

// Bins to Threshold

export function binsToThreshold(bins) {
    const thresholds = [];
    for (let index = 1; index < bins.length; index++) {
        const bin = bins[index];
        thresholds.push(bin[0]);
    }
    return thresholds;
}


// Text Display below map -->
//             <!-- we use a 50,50 coordinate system so we can position things relatively -->

//               <!-- <Section
//                 x1={0}
//                 x2={viewBoxWidth}
//                 y1={0}
//                 y2={viewBoxHeight}
//                 scaleX={scaleLinear().domain([0, 50])}
//                 scaleY={scaleLinear().domain([0, 50])}
//               >
//                 {#if selectedWard === ''}
//                   <Title
//                     title={'Hover over the map for details about the selected ward.'}
//                     titleAnchorPoint={'bl'}
//                     x={25}
//                     y={25}
//                     usePadding={false}
//                     titleFontFamily={'Hind'}
//                     titleFontWeight={'normal'}
//                     titleFontSize={14} />
//                 {:else}
//                   <Title
//                     title={selectedWard}
//                     titleAnchorPoint={'bl'}
//                     x={25}
//                     y={25}
//                     usePadding={false}
//                     titleFontFamily={'Hind'}
//                     titleFontWeight={'normal'}
//                     titleFontSize={14} />
//                 {/if}

//               </Section>

